import f from "react";
import { I as l } from "./init-promise-deferred.util-29i-jPRG.mjs";
function d(e, r) {
  return e.replace(/[A-Z]/g, (o) => `${r}${o.toLowerCase()}`);
}
const c = window;
function w(e, r, o) {
  const t = `__${e}_${d(r, "_")}`, n = Math.floor(Math.random() * 1e9).toString(), s = `${t}_${n}`;
  c[t] = o;
  const i = c[t];
  return i && delete c[i], c[t] = s, c[s] = o, s;
}
function $({ meta: e }, r, o, t) {
  switch (e.props[r]) {
    case "function":
      return w(t, r, o);
    case "json":
      return JSON.stringify(o);
    default:
      return o;
  }
}
async function _(e) {
  var r, o;
  try {
    return await l.$promise.then(async () => await importShim(e).then(({ meta: n }) => {
      const s = Math.floor(Math.random() * 1e9).toString();
      return {
        default: (i) => f.createElement(
          n.tag,
          Object.entries(i).reduce(
            (m, [u, a]) => ({
              ...m,
              [d(u, "-")]: $({ meta: n }, u, a, s)
            }),
            {}
          )
        )
      };
    }));
  } catch (t) {
    console.error(t);
    const n = ((r = e == null ? void 0 : e.split("/")) == null ? void 0 : r[0]) ?? "", s = ((o = e == null ? void 0 : e.split("/")) == null ? void 0 : o[1]) ?? e;
    throw new Error(
      `Couldn't load remote module, did you forgot to pass ${n} to initMfes? And are you sure ${s} is being exposed from ${n}?`
    );
  }
}
export {
  _ as loadRemoteModule
};
